import { FETCH_INVENTORY_RES } from '../actions/types';

export default function (state = [], action) {
  switch (action.type) {
    case FETCH_INVENTORY_RES:
      return action.payload;

    default:
      return state;
  }
}
